import React from "react";
import { useSelector } from "react-redux";
import CustomLayout from "../General/CustomLayout/CustomLayout";
import MarketPackageList from "../General/MarketPackageList/MarketPackageList";
import BuildTargetsHeader from "./BuildTargetsHeader";
import BuildTargetsFooter from "./BuildTargetsFooter";
import CountryList from "../General/CountryList/CountryList";

import useSelectedMPCountry from "../../hooks/BuildTargets/useSelectedMPCountry";
import useCountryFromMarketPackage from "../../hooks/BuildTargets/useCountryFromMarketPackage";
import OneIntelligenceServices from "../../services/OneIntelligence.services";
import useMarketPackageLoading from "../../hooks/BuildTargets/useMarketPackageLoading";

const BuildTargets = function () {
    const {
        marketPackages,
        setup: {
            marketPackage, country
        },
        editTarget
    } = useSelector((state) => state.buildTargets);
    // Custom Hooks
    const {
        activeKey, selectedCountry, selectedMP,
        setactiveKey, setselectedCountry, setselectedMP
    } = useSelectedMPCountry(marketPackage, country, editTarget);

    const isLoadingMP = useMarketPackageLoading(marketPackages);
    const countryList = useCountryFromMarketPackage(selectedMP);

    return (
        <CustomLayout
            className="buildtargets"
            classNameHeader="buildtargets-header"
            classNameBody="buildtargets-body"
            header={<BuildTargetsHeader />}
            contentSiblings={(
                <BuildTargetsFooter
                    selectedCountry={selectedCountry}
                    selectedMP={selectedMP}
                />
            )}
        >
            <div className="buildtargets-holder">
                <CustomLayout
                    className="buildtargets-marketpackage"
                    classNameHeader="buildtargets-marketpackage-header noborder"
                    classNameBody="buildtargets-marketpackage-body"
                    header={(
                        <>
                            <div className="buildtargets-title">Analysis</div>
                            <div className="buildtargets-subtitle">
                                What would you like to explore today?
                            </div>
                        </>
                    )}
                >
                    <MarketPackageList
                        marketPackages={marketPackages}
                        loading={isLoadingMP}
                        loadingItemCount={7}
                        activeKey={activeKey}
                        selected={selectedMP}
                        setSelected={(e, slctdObj) => {
                            setselectedCountry(null);
                            setselectedMP(slctdObj);
                        }}
                        setActiveKey={setactiveKey}
                    />
                </CustomLayout>
                <div className="buildtargets-between-border" />
                <CustomLayout
                    className="buildtargets-info flex-1"
                    classNameHeader="buildtargets-info-header noborder"
                    classNameBody="buildtargets-info-body"
                    header={(
                        <>
                            <div className="buildtargets-title">Select Market</div>
                            <div className="buildtargets-subtitle">
                                {/* Configure your target parameters. You may still change them later. */}
                            </div>
                        </>
                    )}
                >
                    <CountryList
                        hideLoadingCountry
                        countryList={countryList}
                        setselectedCountry={setselectedCountry}
                        marketPackage={marketPackage}
                        selectedCountry={selectedCountry}
                        // forceAvailableList={OneIntelligenceServices.getAvailableCountryList()}
                    />
                </CustomLayout>
            </div>
        </CustomLayout>
    );
};

export default BuildTargets;
